import { account } from './account.js';
import { profiles } from './profiles.js';
import { catalog } from './catalog.js';

/* Proveedores compartidos con otra cuenta: mientras se reproduce uno de ellos (el propio compartido o uno recibido) se avisa al
   servidor cada pocos segundos. Con el límite de conexiones del proveedor, el dueño manda: si el invitado sobra, el servidor
   contesta {evict: true} y el reproductor se cierra con un aviso. Si el proveedor no se comparte, no se envía nada. */

export const BEAT_MS = 30000;

/** Otras vías de compartir (las apps sin cuenta usan invitaciones por código): { applies(profile), beat(profile, {sid, max, stop}) → {evict, revoked} }. */
export const beatSources = [];

/** ¿Hay que avisar por este proveedor? Solo si es compartido o si el dueño lo comparte con alguien. */
export function needsBeat(profile) {
    return !!profile && (!!profile.shared || (Array.isArray(profile.sharedWith) && profile.sharedWith.length > 0) || beatSources.some((x) => x.applies(profile)));
}

export function initSharedUse({ player, notify, t }) {
    let timer = null;
    let sid = '';
    let lastPid = '';

    const current = () => {
        const route = player.route || null;
        const pid = (route && route.pid) || (catalog && catalog.id) || '';
        return { pid, profile: pid ? profiles.get(pid) : null };
    };
    const viaAccount = (profile) => !!profile && account.signedIn && !profile.viaCode && (!!profile.shared || (Array.isArray(profile.sharedWith) && profile.sharedWith.length > 0));
    const beat = async () => {
        if (!player.isOpen) return;
        const { pid, profile } = current();
        if (!needsBeat(profile)) return;
        lastPid = pid;
        let max = 0;
        try { max = Number((catalog.subscriptionOfSource(pid) || {}).max) || 0; } catch (e) { max = 0; }
        try {
            let r = null;
            if (viaAccount(profile)) r = await account.playingBeat({ profileId: pid, sessionId: sid, max });
            for (const src of beatSources) if (src.applies(profile)) r = Object.assign(r || {}, await src.beat(profile, { sid, max }));
            if (r && r.revoked) notify.toast(t('share.revoked', { name: (profile && profile.name) || '' }), { icon: 'link_off', duration: 6000 });
            if (r && (r.evict || r.revoked) && player.isOpen) {
                player.close();
                if (r.evict) notify.toast(t('share.evicted', { name: (profile && profile.name) || '' }), { icon: 'lock_clock', duration: 6000 });
            }
        } catch (e) { /* sin red o sin sesión: no se molesta */ }
    };
    const stop = () => {
        clearInterval(timer);
        timer = null;
        const profile = lastPid ? profiles.get(lastPid) : null;
        if (profile && viaAccount(profile)) account.playingBeat({ profileId: lastPid, sessionId: sid, stop: true }).catch(() => {});
        if (profile) beatSources.forEach((src) => { if (src.applies(profile)) src.beat(profile, { sid, max: 0, stop: true }).catch(() => {}); });
        lastPid = '';
    };
    player.on('open', () => {
        stop();
        sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
        beat();
        timer = setInterval(beat, BEAT_MS);
    });
    player.on('change', () => { if (player.isOpen) beat(); });
    player.on('close', stop);
}
